import React from 'react'
import "./styles.css"

const InternshipCard = (props) => {
    const openGoogleForm = () => {
        const googleFormUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSdOHwV2mcNyWaTAOgCtFgmMUzmGyXpEbmIuGRRI2kGsn4uNfQ/viewform?usp=sf_link';
        window.open(googleFormUrl, '_blank');
    };


    var itemsArray = props.content.split(",")
    console.log(itemsArray)
    return (
        <div className='internship-card'>
            <div className='heading-container'><h3>{props.heading}</h3></div>
            <div className='list-container'>
                {itemsArray?.map(item => <p>{item}</p>)}
            </div>
            <button className='apply' onClick={openGoogleForm}>Apply Now</button>
        </div>
    )
}

export default InternshipCard
